import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
const ApInvoices = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-3">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      AP Invoices
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center w-100 mx-0">
                      <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>

                      <div className="btns col-sm-7 col-12 align-right px-0 d-flex align-items-center justify-content-end">
                        <div className="field text-right">
                          <button
                            class="btn green-btn-revert add-plus addSp mx-0"
                            id="addCount"
                            type="button"
                          >
                            <i class="i-icon"> </i> Add Invoice
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy mt-0 mb-3">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                    <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>

                  <div class="selecters col-lg-5 col-md-6 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                    <div class="select-div col-12 col-lg-5 px-1">
                      <div class="input select">
                        <select
                          name="waste_group"
                          class="csutom_select"
                          id="WasteWasteGroup"
                        >
                          <option value="">Status</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div className="shadowclass mt-0">
                  <div className="table-responsive general-setting saved_order_ms">
                    <div className="orderList">
                      <table className="checklist-table remove-space">
                        <thead>
                          <tr>
                            <th> ID </th>
                            <th className="col-2 min-wd-200"> Payee </th>
                            <th className="col-2">Status</th>
                            <th className="col-2">Total</th>
                            <th className="col-2 min-wd-150"> Contact </th>
                            <th className="min-wd-150">Created</th>
                            <th className="min-wd-150">Updated</th>
                            <th className="action-td">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="order_row">
                            <td>AP0000030</td>
                            <td>
                              <b>6 Drunk Men Pte Ltd</b> <br />
                              ID INV6667 (2022-05-16){" "}
                            </td>
                            <td>
                              <span class="green_tag"> Verified </span>
                            </td>
                            <td>$535.00 </td>
                            <td class="contact-sec-td">TBD@tbd.com</td>
                            <td>May 16, 2022</td>
                            <td>May 16, 2022</td>
                            <td className="action-td">
                              <a
                                class="circle_icon"
                                href="/ap_invoices/view/127"
                              >
                                {" "}
                                <i class="iconSprites eye-icon">
                                  <div class="tooltip-sm"> View </div>
                                </i>
                              </a>
                            </td>
                          </tr>
                          <tr class="order_row">
                            <td>AP0000028</td>
                            <td>
                              <b>A-Speed Infotech Pte Ltd</b> <br />
                              ID 00000000013 (2022-05-13){" "}
                            </td>
                            <td>
                              <span class="pending"> Pending </span>
                            </td>
                            <td>$2,140.00 </td>
                            <td class="contact-sec-td">TBD@tbd.com</td>
                            <td>May 13, 2022</td>
                            <td>May 13, 2022</td>
                            <td className="action-td">
                              <a class="circle_icon edit_tooltip">
                                <i class="iconSprites edit-icon"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default ApInvoices;
